import { Divider, Typography } from "@suraasa/placebo-ui"
import { SubmissionAttachment } from "api/resources/assignments/types"
import Attachment from "features/Assignments/Attachment"
import { countWords } from "features/Assignments/TextEditor/hooks/countWords"
import { useSkillEvidenceStyles } from "utils/hooks/useSkillEvidenceStyles"

import Paper from "../Paper"

type Props = {
  content: string
  references?: string | null
  citations?: string | null
  attachments: SubmissionAttachment[]
}
const Submission = ({ references, content, attachments, citations }: Props) => {
  const styles = useSkillEvidenceStyles()
  const contentWordCount = countWords(content)
  const referencesWordCount = countWords(references || "")
  const citationsWordCount = countWords(citations || "")

  const noContent = contentWordCount === 0 && attachments.length === 0

  return (
    <Paper>
      {noContent && (
        <Typography>No content was posted in this submission</Typography>
      )}

      <Typography variant="body">
        <div
          className={styles.className}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </Typography>

      {referencesWordCount > 0 && (
        <div className="mt-4">
          <Typography variant="title3" className="mb-1">
            References
          </Typography>
          <Typography variant="body">
            <div
              className={styles.className}
              dangerouslySetInnerHTML={{ __html: references! }}
            />
          </Typography>
        </div>
      )}

      {citationsWordCount > 0 && (
        <div className="mt-4">
          <Typography variant="title3" className="mb-1">
            Citations
          </Typography>
          <Typography variant="body">
            <div
              className={styles.className}
              dangerouslySetInnerHTML={{ __html: citations! }}
            />
          </Typography>
        </div>
      )}

      {attachments.length > 0 && (
        <>
          <Divider weight="light" className="my-2.75 bg-onSurface-200" />
          <div className="flex flex-wrap items-center justify-between gap-1 sm:justify-start">
            {attachments.map((attachment, index) => (
              <Attachment key={index} file={attachment} />
            ))}
          </div>
        </>
      )}
    </Paper>
  )
}

export default Submission
